import React, { useEffect, useState } from "react";
import { Button, Grid, Typography, Box, Tooltip, IconButton, MenuItem } from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import {
    ErrorCommon,
    SelectField,
    TextField,
    TextFieldCommon,
    PhoneNumberField,
    NumberTextField,
    SSNNumberField, AutoComplete,
} from "../../../../../components/formikFormInputs";
//import { NumberTextField } from "../../../../../component/formInputs";
import {Field, Formik, useFormikContext} from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducers";
import { useActions } from "../../../../../actions";
import * as Actions from "../../../../../actions/account";
import * as Estimations from "../../../../../actions/estimation";
import {
    genderDropDown,
    stateDropDown,
    healthDropdown,
    minContributionAmount,
    trustFeeText,
} from "../../../../../constants";
import { Label } from "../../../../../components/formInputs";
import moment from "moment";
import AllianzAlert from "../../component/AllianzAlert";
import IncomeAlert from "../../component/IncomeAlert";
import { getCurrentYear } from "../../../../../utils/dateUtils";
import NumberFormat from "react-number-format";
import InfoIcon from "@material-ui/icons/Info";
import numeral from "numeral";
import InputAdornment from "@material-ui/core/InputAdornment";
import { checkProofExpiry } from "../../../../../utils/commonUtils";
import * as ClientActions from "../../../../../actions/client";
import FocusError from "../../../../../components/FocusError";

type placeObj = { id: number, key?: string, name: string, value: string };

let stateDropDownArr: placeObj[] = stateDropDown.map((state: any) => {
    return {
        id: state.id,
        title: state.name,
        key: state.value,
        name: state.name,
        value: state.value,
    };
});


const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const getMonths = () => {
    return months.map((month: string, index: number) => {
        return {
            id: index + 1,
            key: index + 1,
            name: month,
        };
    });
};

const getYears = () => {
    const years: any = [];
    for (let year = new Date().getFullYear(); year >= 1930; year--) {
        years.push({
            id: year,
            key: year,
            name: year,
        });
    }
    return years;
};

export const getNextYears = () => {
    const years: any = [];
    for (let year = new Date().getFullYear(); year <= new Date().getFullYear() + 50; year++) {
        years.push({
            id: year,
            key: year,
            name: year,
        });
    }
    return years;
};
const lastDayOfMonth = (y: number, m: number) => {
    return new Date(y, m, 0).getDate();
};

const getNumberOfPolicies = () => {
    const policies: any = [];
    for (let i = 1; i <= 4; i++) {
        policies.push({
            id: i,
            key: i,
            value: i,
            name: i,
        });
    }
    return policies;
};

const healthDropdownOtpions = healthDropdown.map((item: any, index) => {
    return {
        id: item.value,
        value: item.value,
        name: item.name,
    };
});

const employedTimeArr: any = [];
const getEmployedTime = () => {
    for (let i = 1; i <= 65; i++) {
        employedTimeArr.push({
            id: i + "",
            key: i + "",
            name: i + `${i === 1 ? " year" : " years"}`,
        });
    }
    return employedTimeArr;
};
const employedTimeDropDown = getEmployedTime();

const formatSSN = (ssn: any) => {
    if (!ssn) {
        return "";
    }
    if (ssn.length < 9) {
        return "";
    }

    let pattern = new RegExp("\d{3}[\-]\d{2}[\-]\d{4}");
    let value = ssn;
    let res = pattern.test(value);
    if (!res) {
        value = value
                .match(/\d*/g).join("")
                .match(/(\d{0,3})(\d{0,2})(\d{0,4})/).slice(1).join("-")
                .replace(/-*$/g, "");
    }
    return value;
};

const PersonalDetailForm = (props: { setNextStep: Function, setActionItem: Function, isFromClientDetail?: boolean, clientDetail?: any, setPersonalDetailRef?: Function, setIsPersonalFormDirty?: Function, setIsFormSubmitting?: Function, setCarrierValAlert?: Function, setValidationError?: Function, setStateValue?: Function, communityStateVal?: string, setCommunityStateVal?: Function}) => {
    const {
        setNextStep,
        isFromClientDetail,
        setPersonalDetailRef,
        setIsPersonalFormDirty,
        setIsFormSubmitting,
        setCarrierValAlert,
        setActionItem,
        setValidationError,
        setStateValue,
        communityStateVal,
        setCommunityStateVal
    } = props;
    const [days, setDays] = React.useState([{
        id: "",
        key: "",
        name: "",
    }]);
    const accountActions = useActions(Actions);
    const estimationActions = useActions(Estimations);
    const { getClient } = useActions(ClientActions);
    let userData = useSelector((state: RootState) => state.profile);
    let { user: { role } } = useSelector((state: RootState) => state.auth);
    let user = props.clientDetail || userData;
    const { client } = user;
    const clientPolicy = client && client.clientPolicies.length > 0 && client.clientPolicies[0];
    const conditionalRequired = !(role === 1 || role === 2 || role === 4);
    const clientSigned = clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned ? 1 : 0;
    const [existPolicies, setExistPolicies] = React.useState(false);
    const [age, setAge] = React.useState("");
    const [selfEmployed, setSelfEmployed] = React.useState(false);
    const [carrierId, setCarrierId] = React.useState<number | null>(null);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [employedTimeCount, setEmployedTimeCount] = React.useState(0);
    const [allianzId, setAllianzId] = React.useState<number | null>(null);
    const [carrierName, setCarrierName] = React.useState<string | undefined>("");
    const [minVal, setMinVal] = React.useState(minContributionAmount);
    const [ageSelected, setAgeSelected] = React.useState(false);
    const [incomeAlertOpen, setIncomeAlertOpen] = React.useState(false);
    const [proofExpired, setProofExpired] = React.useState(false);
    const [nationalLifeId, setNationalLifeId] = React.useState<number | null>(null);
    const [isNationalLife, setIsNationalLife] = React.useState<boolean>(false);
    const [isAllianzLife, setIsAllianzLife] = React.useState<boolean>(false);
    const [minAge, setMinAge] = React.useState<number>(18);
    const [maxAge, setMaxAge] = React.useState<number>(65);
    const [strategySlug, setStrategySlug] = React.useState("");
    const [labelsActive, setLabelsActive] = React.useState<any[]>([]);
    const [stateObj, setStateObj] = React.useState<{} | string>("");
    const [refresh, setRefresh] = React.useState(0);
    const currentYear = getCurrentYear();
    const personalDetailSubmit = React.useRef<any>();
    const getAllianzCarrierDetails = async () => {
        const allianzData = await accountActions.getAllianzDetails();
        setAllianzId(allianzData.allianzLife.id);
    };
    const getNatioanlLifeCarrierDetails = async () => {
        const nationalLifeDate = await accountActions.getNationalLifeDetails();
        if (nationalLifeDate && nationalLifeDate.nationalLife) {
            setNationalLifeId(nationalLifeDate.nationalLife.id);
        }
    };

    React.useEffect(() => {
        if (isNationalLife) {
            setMinAge(18); //for National Life Carrier MIN AGE is 18;
            setMaxAge(65);
        }
    }, [isNationalLife]);

    React.useEffect(() => {
        if (isAllianzLife) {
            setMinAge(18); //for National Life Carrier MIN AGE is 18;
            setMaxAge(65);
        }
    }, [isAllianzLife]);

    React.useEffect(() => {
        if (nationalLifeId && carrierId && nationalLifeId === carrierId && strategySlug === "kaizen") {
            setIsNationalLife(true);
        }
    }, [nationalLifeId, carrierId]);

    React.useEffect(() => {
        if (allianzId && carrierId && allianzId === carrierId && strategySlug === "kaizen") { //if Allianz Life and strategy is Kaizen
            setIsAllianzLife(true);
        }
    }, [allianzId, carrierId]);

    React.useEffect(() => {
        if (typeof setCarrierValAlert === "function") {
            setCarrierValAlert(openAlert);
        }
    }, [openAlert]);

    useEffect(() => {
        if (personalDetailSubmit.current && typeof setPersonalDetailRef === "function") {
            setPersonalDetailRef(personalDetailSubmit);
        }
    }, [personalDetailSubmit.current]);

    useEffect(() => {
        if (!isFromClientDetail) {
            accountActions.getProfileDetails();
        }
        getAllianzCarrierDetails();
        getNatioanlLifeCarrierDetails();
    }, []);

    useEffect(() => {
        if (client) {
            setSelfEmployed(clientPolicy.selfEmployed ? true : false);
            getDays();
        }
        if (clientPolicy && clientPolicy.employedTime) {
            setEmployedTimeCount(clientPolicy.employedTime);
        }
        if (clientPolicy && clientPolicy.existPolicies) {
            setExistPolicies(!!clientPolicy.existPolicies);
        }
        if (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id) {
            setCarrierId(clientPolicy.carrier.id);
            setCarrierName(clientPolicy.carrier.carrierName);
        }
        if (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug) {
            setStrategySlug(clientPolicy.strategy.slug);
        }
        if (client && client.dob) {
            let birthDate = client && client.dob || "";
            let birthMonth: number = 0;
            let birthDay: number = 0;
            let birthYear: number = 0;
            if (birthDate) {
                let birthDateArr = birthDate.split("-");
                birthYear = Number(birthDateArr[0]);
                birthMonth = Number(birthDateArr[1]);
                birthDay = Number(birthDateArr[2]);
            }
            const date = new Date(birthYear, birthMonth, birthDay);
            const age = moment().diff(date, "years");
            setAge(age + "");
            setAgeSelected(age && (age >= minAge && age <= maxAge) ? true : false);
            getDays(birthYear, birthMonth);
        }
        if (clientPolicy && clientPolicy.employeeIdExpireDate) {
            const expireDate = moment(new Date(clientPolicy.employeeIdExpireDate));
            const currentDate = moment(new Date());
            const daysLeft = expireDate.diff(currentDate, "days");
            if (daysLeft <= 0) {
                setProofExpired(true);
            }
        }
        if (client && client.state) {
           const stateObj: any =  stateDropDown.find((item:any,index)=>{
                return item.value === client.state
            })
           setStateObj({
               key: stateObj && stateObj.value,
               name: stateObj && stateObj.name,
               title: stateObj && stateObj.name
           });
            setRefresh(Math.random());
        }
    }, [client]);

    const getDays = (year: number = 2020, month: number = 1) => {
        let lastDay: number = lastDayOfMonth(year, month);
        let day: any = [];
        for (let index = 1; index <= lastDay; index++) {
            day.push({
                id: index,
                key: index,
                name: index,
            });
        }
        setDays(day);
        return day;
    };

    let birthDate = client && client.dob || "";
    let birthMonth: number = 0;
    let birthDay: number = 0;
    let birthYear: number = 0;
    if (birthDate) {
        let birthDateArr = birthDate.split("-");
        birthYear = Number(birthDateArr[0]);
        birthMonth = Number(birthDateArr[1]);
        birthDay = Number(birthDateArr[2]);
    }

    let proofExpireDate = clientPolicy && clientPolicy.employeeIdExpireDate;
    let proofExpiryYear = 0;
    let proofExpiryMonth = 0;
    if (proofExpireDate) {
        let proofExpireDateArr = proofExpireDate.split("-");
        proofExpiryYear = Number(proofExpireDateArr[0]);
        proofExpiryMonth = Number(proofExpireDateArr[1]);
    }
    React.useEffect(() => {
        getEstimation();
    }, []);

    const getEstimation = async () => {
        if (client) {
            getContributionAmount({
                contributionAmount: 0,
                age: client.age,
                rating: clientPolicy.healthType,
                gender: client.gender,
            });
        }
    };

    const getContributionAmount = (data: any) => {
        setTimeout(async () => {
            let estimatorData: any = await estimationActions.getInvitedClientEstimates({
                age: data.age || minAge,
                gender: data.gender === 1 ? "Male" : "Female",
                rating: data && data.rating || "Standard",
                contribution: numeral(data.contributionAmount).value() + "",
                strategySlug: clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug || "",
                carrierName: clientPolicy && clientPolicy.carrier && clientPolicy.carrier.carrierName || "",
            });
            if (estimatorData && estimatorData.payload && estimatorData.payload.minContributionAmount) {
                setMinVal(estimatorData && estimatorData.payload && estimatorData.payload.minContributionAmount);
            }
        }, 500);
    };

    let formVal = {
        usCitizen: clientPolicy && clientPolicy.usCitizen ? true : false,
        identityType: clientPolicy && clientPolicy.identityType || "drivingLicence",
        identityId: client && client.employeeIdNumber || "",
        employeeSSN: formatSSN(client && client.employeeSSN || ""),
        blotSSN: client && client.blotSSN || "",
        birthState: client && client.birthState || "",
        birthCountry: client && client.birthCountry || "",
        firstName: user.firstName || "",
        middleName: user.middleName || "",
        lastName: user.lastName || "",
        cellPhone: user.phoneNumber || "",
        email: user.email || "",
        workPhoneNumber: client && client.workPhoneNumber || "",
        gender: client && client.gender || "",
        birthMonth: birthMonth,
        birthDay: birthDay,
        birthYear: birthYear,
        age: moment().diff(client && client.dob, "years") || client && client.age || age,
        street: client && client.street || "",
        city: client && client.city || "",
        state: stateObj || {key: "", name: "", title: ""},
        zipCode: client && client.zipCode || "",
        isDocumentAddress: clientPolicy && clientPolicy.isDocumentAddress ? true : false,
        selfEmployed: clientPolicy && clientPolicy.selfEmployed ? true : false,
        employer: clientPolicy && clientPolicy.employer || "",
        employedTime: clientPolicy && clientPolicy.employedTime || "",
        annualIncome: clientPolicy && clientPolicy.annualIncome && Number(clientPolicy.annualIncome).toString() || "",
        annualIncome1: clientPolicy && clientPolicy.annualIncome1 && Number(clientPolicy.annualIncome1).toString() || "",
        annualIncome2: clientPolicy && clientPolicy.annualIncome2 && Number(clientPolicy.annualIncome2).toString() || "",
        householdAnnualIncome: clientPolicy && clientPolicy.householdAnnualIncome && Number(clientPolicy.householdAnnualIncome).toString() || "",
        householdNetWorth: clientPolicy && clientPolicy.householdNetWorth && Number(clientPolicy.householdNetWorth).toString() || "",
        occupation: clientPolicy && clientPolicy.occupation || "",
        healthType: clientPolicy && clientPolicy.healthType || "",
        existPolicies: clientPolicy && clientPolicy.existPolicies ? true : false,
        noOfPolicies: clientPolicy && clientPolicy.noOfPolicies || "",
        contributionAmount: clientPolicy && clientPolicy.issuedContribution || clientPolicy && clientPolicy.contributionAmount || "",
        proofExpiryYear: proofExpiryYear,
        proofExpiryMonth: proofExpiryMonth,
        employeeIdState: clientPolicy && clientPolicy.employeeIdState || "",
    };
    const [initialValues, setInitialValues] = React.useState(formVal);

    useEffect(() => {
        if (client) {
                setInitialValues({...formVal, state: stateObj});
        }
    }, [client]);

    useEffect(()=>{
        if(isFromClientDetail && communityStateVal){
            const stateList = JSON.parse(JSON.stringify(stateDropDown));
            const stateObjFound: any =  stateList.find((item:any,index)=>{
                return item.value === communityStateVal
            })
            if (stateObjFound) {
                setStateObj({
                    key: stateObjFound && stateObjFound.value,
                    name: stateObjFound && stateObjFound.name,
                    title: stateObjFound && stateObjFound.name
                });
                stateObjFound.key = stateObjFound && stateObjFound.value;
                stateObjFound.title = stateObjFound && stateObjFound.name;
                delete stateObjFound.isCommunityState;
                delete stateObjFound.id;
                delete stateObjFound.value;
                setTimeout(() => {
                    setInitialValues(Object.assign({}, {...initialValues, state: stateObjFound}))
                }, 500);
                setTimeout(() => {
                    if (typeof setCommunityStateVal === 'function') {
                        setCommunityStateVal("");
                    }
                }, 1000)
            }
        }
    },[communityStateVal])

    const fieldObj = [
        {
            name: "identityId",
            helperFieldText: "Must be a valid drivers license",
            label: <Label label={"Enter drivers license number"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            className: "mt35 TextFieldWidth",
            filedType: "string",
            component: TextField,
            variant: "outlined",
        },
    ];
    const fieldObj1 = [
        {
            name: "employeeSSN",
            id: "employeeSSN",
            helperFieldText: "What's ITIN.",
            label: <Label label={"Enter ITIN Number"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: SSNNumberField,
            filedType: "string",
            variant: "outlined",
            className: "TextFieldWidth mt15",
        },
        {
            id: "blotSSN",
            name: "blotSSN",
            component: TextField,
            className: "TextFieldWidth mt15",
            label: "SSN (last 4 digits)",
            disabled: true,
            variant: "outlined",
        },
        {
            name: "birthCountry",
            label: <Label label={"Birth Country"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: TextField,
            className: "TextFieldWidth mt20",
            variant: "outlined",
            onSelectChange: (val: number) => {
            },
        }, {
            name: "birthState",
            component: TextField,
            className: "TextFieldWidth",
            label: "Birth State",
            variant: "outlined",
            onSelectChange: (val: number) => {
            },
        }, {
            name: "firstName",
            label: <Label label={"First Name"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            helperFieldText: "Must match drivers license",
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        },
        {
            name: "middleName",
            label: "Middle Name",
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        },
        {
            name: "lastName",
            label: <Label label={"Last Name"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            helperFieldText: "Must match drivers license",
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        },
        {
            id: "cellPhone",
            name: "cellPhone",
            label: <Label label={"Cell Phone"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: PhoneNumberField,
            variant: "outlined",
            className: "TextFieldWidth",
        },
        {
            name: "email",
            label: <Label label={"Email"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            disabled: true,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        },
        {
            id: "workPhoneNumber",
            name: "workPhoneNumber",
            label: <Label label={"Work Phone"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: PhoneNumberField,
            variant: "outlined",
            className: "TextFieldWidth",
        }, {
            name: "gender",
            label: <Label label={"Gender"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            options: genderDropDown,
            onSelectChange: (val: number) => {
            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                getContributionAmount({
                    contributionAmount: 0,
                    age: formValues.age,
                    rating: formValues.healthType,
                    gender: val,
                });
            },
        },
    ];

    const setAnticipatedAge = (date, setValue, formValues) => {
        const age = moment().diff(date, "years");
        setAgeSelected(age && (age >= minAge && age <= maxAge) ? true : false);
        getContributionAmount({
            contributionAmount: 0,
            age: age,
            rating: formValues.healthType,
            gender: formValues.gender,
        });
        setValue("age", age);
    };

    const fieldObj4 = [
        {
            name: "birthMonth",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            isRequired: conditionalRequired,
            filedType: "selectbox",
            label: "Month",
            options: getMonths(),
            onSelectChange: (val: number) => {
            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                const day = formValues["birthDay"];
                const year = formValues["birthYear"];
                const month = val;
                const date = new Date(year, month, day);
                setAnticipatedAge(date, setValue, formValues);
                getDays(year, month);
                setValue("birthMonth", val);
            },
        },
        {
            name: "birthDay",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            isRequired: conditionalRequired,
            label: "Day",
            options: days,
            onSelectChange: (val: number) => {
            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                const day = val;
                const year = formValues["birthYear"];
                const month = formValues["birthMonth"];
                const date = new Date(year, month, day);
                setAnticipatedAge(date, setValue, formValues);
                setValue("birthDay", val);
            },
        },
        {
            name: "birthYear",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            isRequired: conditionalRequired,
            label: "Year",
            options: getYears(),
            onSelectChange: (val: number) => {

            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                const day = formValues["birthDay"];
                const year = val;
                const month = formValues["birthMonth"];
                const date = new Date(year, month, day);
                setAnticipatedAge(date, setValue, formValues);
                getDays(year, month);
                setValue("birthYear", val);
            },
        },
    ];

    const fieldObj2 = [
        {
            id:"street",
            name: "street",
            label: <Label label={"Street"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            filedType: "string",
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        }, {
            id:"city",
            name: "city",
            label: <Label label={"City"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        },
        {
            id: "state",
            name: "state",
            label: <Label label={"State"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            placeholder: "search state",
            cb: (value)=> {
            },
            component: AutoComplete,
            className: "SelectFieldWidth",
            variant: "outlined",
            contentList: stateDropDownArr,
            onSelectChange: (val: string) => {
                if(typeof setStateValue === 'function') {
                    setStateValue(val);
                }
            },
            needUpdate: communityStateVal ? true :  false
        },
        {
            id:"zipCode",
            name: "zipCode",
            label: <Label label={"Zip Code"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        }];

    const fieldObj3 = [
        {
            id:"employer",
            name: "employer",
            label: <Label label={"Company Name"} required={conditionalRequired ? true : false}/>,
            isRequired: conditionalRequired ? true : false,
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
        },
        {
            id:"employedTime",
            name: "employedTime",
            label: <Label label={"Time Employed"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            helperFieldText: "With your current employer.",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            options: employedTimeDropDown,
            onSelectChange: (val: number) => {

            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                setValue("employedTime", val);
                setEmployedTimeCount(val);
            },
        },
        {
            id: "annualIncome",
            name: "annualIncome",
            label: <Label label={`${currentYear - 1}(year) Annual Income`} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            helperFieldText: "Your personal income.",
            component: NumberTextField,
            variant: "outlined",
            className: "TextFieldWidth dollerIcon",
            dollarSign: true,
        },
        {
            id: "annualIncome1",
            name: "annualIncome1",
            label: <Label label={`${currentYear - 2}(year) Annual Income`} required={conditionalRequired}/>,
            isRequired: ((carrierId == allianzId && selfEmployed) || carrierId !== allianzId) && conditionalRequired ? true : false,
            //filedType: "number",
            helperFieldText: "Your personal income.",
            component: NumberTextField,
            variant: "outlined",
            className: "TextFieldWidth dollerIcon",
            dollarSign: true,
        },
        {
            id: "annualIncome2",
            name: "annualIncome2",
            label: <Label label={`${currentYear - 3}(year) Annual Income`} required={conditionalRequired}/>,
            isRequired: ((carrierId == allianzId && selfEmployed) || carrierId !== allianzId) && conditionalRequired ? true : false,
            helperFieldText: "Your personal income.",
            component: NumberTextField,
            variant: "outlined",
            className: "TextFieldWidth dollerIcon",
            dollarSign: true,
        },
        {
            id: "householdAnnualIncome",
            name: "householdAnnualIncome",
            label: <Label label={"Household Annual Income"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            helperFieldText: "Can be combined with a spouse.",
            component: NumberTextField,
            variant: "outlined",
            className: "TextFieldWidth dollerIcon",
            dollarSign: true,
        },
        {
            id: "householdNetWorth",
            name: "householdNetWorth",
            label: <Label label={"Household Net Worth"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            helperFieldText: "Can be combined with a spouse.",
            component: NumberTextField,
            variant: "outlined",
            className: "TextFieldWidth dollerIcon",
            dollarSign: true,
        }, {
            id:"occupation",
            name: "occupation",
            label: <Label label={"Occupation and Specific Work Duties"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            helperFieldText: "Your position and a short description of what you do.",
            component: TextField,
            variant: "outlined",
            className: "TextFieldWidth",
            md: "8",
        },
    ];

    const fieldObj5 = [{
        id:"noOfPolicies",
        name: "noOfPolicies",
        label: <Label label={"Number of Policies"} required={conditionalRequired}/>,
        isRequired: existPolicies && conditionalRequired,
        filedType: "selectbox",
        helperFieldText: "How many policies do you have with us?",
        component: SelectField,
        className: "SelectFieldWidth",
        variant: "outlined",
        options: getNumberOfPolicies(),
        onSelectChange: (val: number) => {
        },
    }];

    const fieldObj6 = [
        {
            name: "contributionAmount",
            id: "contributionAmount",
            label: <Label label={"Client Annual Contribution Amount"} required={false}/>,
            isRequired: false,
            helperFieldText: !conditionalRequired && !client.dob && !ageSelected ?
                    <span className="colorRed">Please enter a birth date</span> : "",
            component: NumberTextField,
            variant: "outlined",
            className: "TextFieldWidth dollerIcon",
            onSelectChange: (val: number) => {
            },
            disabled: !conditionalRequired && !client.dob && !ageSelected ? true : false,
            dollarSign: true,
        }, {
            name: "healthType",
            label: <Label label={"Health"} required={false}/>,
            isRequired: false,
            filedType: "selectbox",
            helperFieldText: <>Learn about health options <Tooltip arrow
                                                                   title={
                                                                       <React.Fragment>
                                                                           <Typography variant="caption"
                                                                                       className="mb0">
                                                                               Excellent health means you
                                                                               are in excellent overall
                                                                               health and don't participate
                                                                               in any hazardous activities
                                                                               or have a history of drug or
                                                                               alcohol abuse. Average health
                                                                               means you may have had some
                                                                               minor health problems in the
                                                                               past, or have a few current
                                                                               lifestyle issues such as high
                                                                               cholesterol obesity.
                                                                           </Typography>
                                                                       </React.Fragment>
                                                                   }
            >
                <IconButton aria-label="Info" color="primary">
                    <InfoIcon/>
                </IconButton>
            </Tooltip></>,
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            options: healthDropdownOtpions,
            onSelectChange: (val: number) => {
            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                getContributionAmount({
                    contributionAmount: 0,
                    age: formValues.age,
                    rating: val,
                    gender: formValues.gender,
                });
            },
        }];

    const fieldObj7 = [
        {
            name: "proofExpiryMonth",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            isRequired: conditionalRequired,
            filedType: "selectbox",
            label: "Month",
            options: getMonths(),
            onSelectChange: (val: number) => {
            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                if (val && formValues["proofExpiryYear"]) {
                    const endOfMonth = moment(formValues["proofExpiryYear"] + "-" + val).endOf("month").format("D");
                    const date = new Date(formValues["proofExpiryYear"] + "-" + val + "-" + endOfMonth);
                    const result = checkProofExpiry(date);
                    setProofExpired(result);
                }
            },
        }, {
            name: "proofExpiryYear",
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            isRequired: conditionalRequired,
            label: "Year",
            options: getNextYears(),
            onSelectChange: (val: number) => {
            },
            getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                if (val && formValues["proofExpiryMonth"]) {
                    const endOfMonth = moment(val + "-" + formValues["proofExpiryMonth"]).endOf("month").format("D");
                    const date = new Date(val + "-" + formValues["proofExpiryMonth"] + "-" + endOfMonth);
                    const result = checkProofExpiry(date);
                    setProofExpired(result);
                }
            },
        }, {
            name: "employeeIdState",
            label: <Label label={"State"} required={conditionalRequired}/>,
            isRequired: conditionalRequired,
            component: TextField,
            className: "TextFieldWidth",
            variant: "outlined",
            options: stateDropDownArr,
            onSelectChange: (val: number) => {
            },
        },
    ];

    const getFieldFocusValue = (name: string) => {
        let findResult: any = labelsActive.find((label: any) => {
            return label.name === name;
        });
        if (!findResult) {
            return false;
        }

        return findResult.value;
    };

    const CommonField = (
            filedProps,
            action: {
                handleChange?: Function,
                handleBlur: Function,
                values?: any,
                errors?: any,
                touched?: any,
                setFieldValue: any
            },
    ) => {
        const { handleChange, handleBlur, values, errors, touched, setFieldValue } = action;
        const { name, helperFieldText, label, dollarSign } = filedProps;
        let fieldLabel = label;
        if (name === "employeeIdState") {
            fieldLabel =
                    <Label label={values["identityType"] === "drivingLicence" ? " DL State" : "Passport State"}
                           required={conditionalRequired}/>;
        }
        if (name === "identityId") {
            fieldLabel =
                    <Label label={values["identityType"] === "drivingLicence" ? "Enter drivers license number" : "Enter passport number"}
                           required={conditionalRequired}/>;
        }
        if (name === "employeeSSN") {
            fieldLabel =
                    <Label label={values["usCitizen"] ? "Enter Social Security Number" : "Enter ITIN Number"}
                           required={conditionalRequired}/>;
        }

        const getHelperText = (name: string, values: any) => {

            if (name === "identityId") {
                return <span
                        className="f12 textLight"> Must be a valid {values["identityType"] === "drivingLicence" ? "drivers license" : "passport"} </span>;
            }

            if (name === "firstName" || name === "lastName") {
                return (
                        values["identityType"] === "drivingLicence" ?
                                <span className="f12 textLight">Must match drivers license</span> :
                                <span className="f12 textLight">Must match passport</span>
                );
            }

            if ((name === "employeeSSN" || name === "blotSSN") && values["usCitizen"]) {
                const ssnButton = () => {
                    if (role !== 1 && role !== 2) {
                        return <></>;
                    }
                    return (
                            <Button size="small" className={"mt5"} onClick={() => {
                                setActionItem(!!client.employeeSSN);
                            }}
                                    variant="contained" color="primary">
                                {name === "employeeSSN" ? "Hide" : "Show"} SSN
                            </Button>
                    );
                };
                return (
                        <>
                        <span className="f12 textLight">What's SSN.
                            <Tooltip
                                    arrow
                                    title={
                                        <React.Fragment>
                                            <Typography
                                                    className="f14 mb0">In the United States, a Social Security number
                                                is a
                                                nine-digit number issued to U.S. citizens, permanent residents, and
                                                temporary residents.</Typography>
                                        </React.Fragment>
                                    }
                            >
                              <IconButton aria-label="Info" className="pd0"
                                          color="primary">
                                  <InfoIcon className="pd0"/>
                              </IconButton>
                            </Tooltip>
                        </span>
                            {name === "blotSSN" ?
                                    ssnButton()
                                    :
                                    (name === "employeeSSN" && values["employeeSSN"] && ssnButton())
                            }
                        </>
                );
            }

            if (name === "employeeSSN" && !values["usCitizen"]) {
                return (
                        <span className="f12 textLight">What's ITIN.
                        <Tooltip
                                arrow
                                title={
                                    <React.Fragment>
                                        <Typography
                                                className="f14 mb0">An Individual Taxpayer Identification Number (ITIN)
                                            is a tax processing number issued by the Internal Revenue
                                            Service. </Typography>
                                    </React.Fragment>
                                }
                        >
                          <IconButton aria-label="Info" className="pd0"
                                      color="primary">
                              <InfoIcon className="pd0"/>
                          </IconButton>
                        </Tooltip>
                    </span>
                );
            }

            return <span className="f12 textLight">{helperFieldText}</span>;
        };

        let InputProps: any = {};
        if (dollarSign) {
            InputProps = {
                startAdornment: <InputAdornment className="margin0"
                                                position="start">$</InputAdornment>,
            };
        }

        return (
                <>
                    <TextFieldCommon
                            {...filedProps}
                            label={fieldLabel || ""}
                            name={name}
                            error={errors[name] && touched[name] && errors[name]}
                            values={values}
                            onChange={handleChange}
                            onBlur={(e) => {
                                handleBlur(e);
                                if (labelsActive.length > 0) {
                                    let isExist = labelsActive.find((label) => label.name === name);
                                    if (isExist) {
                                        let updatedArr: any = labelsActive.map((label) => {
                                            if (label.name === name) {
                                                return { name, value: false };
                                            }
                                            return label;
                                        });
                                        setLabelsActive(updatedArr);
                                    } else {
                                        setLabelsActive([...labelsActive, { name, value: false }]);
                                    }
                                } else {
                                    setLabelsActive([...labelsActive, { name, value: false }]);
                                }
                            }}
                            onFocus={() => {
                                if (labelsActive.length > 0) {
                                    let isExist = labelsActive.find((label) => label.name === name);
                                    if (isExist) {
                                        let updatedArr: any = labelsActive.map((label) => {
                                            if (label.name === name) {
                                                return { name, value: true };
                                            }
                                            return label;
                                        });
                                        setLabelsActive(updatedArr);
                                    } else {
                                        setLabelsActive([...labelsActive, { name, value: true }]);
                                    }
                                } else {
                                    setLabelsActive([...labelsActive, { name, value: true }]);
                                }
                            }}
                            disabled={filedProps.disabled || clientSigned ? true : false}
                            InputProps={InputProps}
                            InputLabelProps={{
                                shrink: dollarSign || values[name] || getFieldFocusValue(name) || false,
                                disabled: false,
                            }}
                    />
                    {getHelperText(name, values)}
                    <ErrorCommon errors={errors} name={name} touched={touched}/>

                </>
        );
    };

    /* Validations of fields set */
    let keysValidation = {};

    fieldObj.forEach((field) => {
        if (field.isRequired) {
            keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number().required("Required Field") : Yup.string().required("Required Field");
        } else {
            keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number() : Yup.string();
        }
    });

    fieldObj1.forEach((field) => {
        if (field.name === "email") {
            keysValidation[field.name] = Yup.string().email("Please enter a valid email").required("Required Field");
        } else if (!isFromClientDetail && (field.name === "cellPhone")) {
            keysValidation[field.name] = Yup.string().transform((o, v) => v.replace(/\D+/g, "")).length(10, "Enter Valid Number").required("Required Field");
        }
        else if (!isFromClientDetail && (field.name === "workPhoneNumber" || field.name === "homePhone")) {
            keysValidation[field.name] = Yup.string().transform((o, v) => v.replace(/\D+/g, "")).length(10, "Enter Valid Number").trim().nullable(true);
        }

        else if (!isFromClientDetail && field.name === "employeeSSN") {
            keysValidation[field.name] = Yup.string().transform((o, v) => v.replace(/\D+/g, "")).length(9, "Enter Valid Number").required("Required Field");
        } else {
            if (field.isRequired) {
                keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number().required("Required Field") : Yup.string().required("Required Field");
            } else {
                console.log('isFromClientDetail', isFromClientDetail, field.name)
                if(isFromClientDetail && (field.name === "cellPhone")){
                    keysValidation[field.name] = Yup.string().transform((o, v) => v.replace(/\D+/g, "")).length(10, "Enter Valid Number");
                }
                else if(isFromClientDetail && (field.name === "workPhoneNumber" || field.name === "homePhone")){
                    keysValidation[field.name] = Yup.string().transform((o, v) => v.replace(/\D+/g, "")).length(10, "Enter Valid Number").trim().nullable(true);
                } else if(isFromClientDetail && field.name === "employeeSSN") {
                    keysValidation[field.name] = Yup.string().transform((o, v) => v.replace(/\D+/g, "")).length(9, "Enter Valid Number");
                } else {
                    keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number() : Yup.string();
                }
            }
        }
    });

    fieldObj4.forEach((field) => {
        if (field.isRequired) {
            if (field.name && (field.name === "birthDay" || field.name === "birthYear" || field.name === "birthMonth")) {
                if (field.name === "birthDay") {
                    keysValidation[field.name] = Yup.number().min(1, "Please select birth day");
                } else if (field.name === "birthYear") {
                    keysValidation[field.name] = Yup.number().min(1, "Please select birth year");
                } else {
                    keysValidation[field.name] = Yup.number().min(1, "Please select birth month");
                }
            } else {
                keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number().required("Required Field") : Yup.string().required("Required Field");
            }
        } else {
            if (field.name && (field.name === "age")) {
                keysValidation[field.name] = Yup.number().min(minAge, `Age should be between ${minAge} and ${maxAge}.`).max(maxAge, `Age should be between ${minAge} and ${maxAge}.`).typeError(`Age should be between ${minAge} and ${maxAge}.`);
            } else {
                keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number() : Yup.string();
            }
        }
    });

    fieldObj7.forEach((field) => {
        if (field.isRequired) {
            if (field.name && (field.name === "proofExpiryMonth" || field.name === "proofExpiryYear")) {
                if (field.name === "proofExpiryMonth") {
                    keysValidation[field.name] = Yup.number().min(1, "Please select expiry month");
                } else if (field.name === "proofExpiryYear") {
                    keysValidation[field.name] = Yup.number().min(1, "Please select expiry year");
                }
            } else {
                keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number().required("Required Field") : Yup.string().required("Required Field");
            }
        }
    });

    fieldObj2.forEach((field) => {
        if (field.isRequired) {
            if(field.name && (field.name === "zipCode")){
                keysValidation[field.name] = Yup.string().required("Required Field").matches(/(^\d{5}$)/, 'Please enter a valid zip code')
            } else if(field.name && (field.name === "state")){
                keysValidation[field.name] = Yup.string().required("Required Field").transform((o, v) => {
                    if(v && typeof v === 'object'){
                        return v.key;
                    }
                    return v || ""
                });
            } else {
                keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number().required("Required Field") : Yup.string().required("Required Field");
            }
        } else {
            if(field.name && (field.name === "zipCode")) {
                keysValidation[field.name] = Yup.string().matches(/(^\d{5}$)/, 'Please enter a valid zip code')
            } else if(field.name && (field.name === "state")){
                keysValidation[field.name] = Yup.string().transform((o, v) => {
                    if(v && typeof v === 'object'){
                        return v.key;
                    }
                    return v || ""
                });
            } else {
                keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number() : Yup.string();
            }
        }
    });

    fieldObj3.forEach((field) => {
        if (field.isRequired) {
            if (field.name && (field.name === "annualIncome")) {
                keysValidation[field.name] = Yup.number().required("Required Field").transform((o, v) => parseInt(v.replace(/,/g, ""))).min(100000, `Minimum value is ${numeral(100000).format("$0,0")}`);
            } else if (((carrierId == allianzId && selfEmployed) || carrierId !== allianzId) && field.name === "annualIncome1") {
                keysValidation[field.name] = Yup.number().required("Required Field").transform((o, v) => parseInt(v.replace(/,/g, ""))).min(100000, `Minimum value is ${numeral(100000).format("$0,0")}`);
            } else if (((carrierId == allianzId && selfEmployed) || carrierId !== allianzId) && field.name === "annualIncome2") {
                keysValidation[field.name] = Yup.number().required("Required Field").transform((o, v) => parseInt(v.replace(/,/g, ""))).min(100000, `Minimum value is ${numeral(100000).format("$0,0")}`);
            } else {
                keysValidation[field.name] = Yup.string().required("Required Field");
            }
        } else {
            if (field.name && (field.name === "annualIncome")) {
                keysValidation[field.name] = Yup.number().nullable(true).transform((o, v) => {
                    return v && parseInt(v.replace(/,/g, "")) || null;
                }).min(100000, `Minimum value is ${numeral(100000).format("$0,0")}`);
            } else if (((carrierId == allianzId && selfEmployed) || carrierId !== allianzId) && field.name === "annualIncome1") {
                keysValidation[field.name] = Yup.number().nullable(true).transform((o, v) => {
                    return v && parseInt(v.replace(/,/g, "")) || null;
                }).min(100000, `Minimum value is ${numeral(100000).format("$0,0")}`);
            } else if (((carrierId == allianzId && selfEmployed) || carrierId !== allianzId) && field.name === "annualIncome2") {
                keysValidation[field.name] = Yup.number().nullable(true).transform((o, v) => {
                    return v && parseInt(v.replace(/,/g, "")) || null;
                }).min(100000, `Minimum value is ${numeral(100000).format("$0,0")}`);
            }
        }
    });

    fieldObj5.forEach((field) => {
        if (field.isRequired) {
            keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number().required("Required Field") : Yup.string().required("Required Field");
        } else {
            keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number() : Yup.string();
        }
    });

    fieldObj6.forEach((field) => {
        if (field.isRequired) {
            keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number().required("Required Field") : Yup.string().required("Required Field");
        } else {
            if (field.name && (field.name === "contributionAmount") && isFromClientDetail && ageSelected) {
                keysValidation[field.name] = Yup.number().transform((o, v) => {
                    return v && parseInt(v.replace(/,/g, "")) || 0;
                }).min(minVal, `Minimum contribution is  ${numeral(minVal).format(" $0,0 ")}`);
            } else {
                keysValidation[field.name] = field.filedType && field.filedType === "number" ? Yup.number() : Yup.string();
            }
        }
    });

    const personalDetailSchema = Yup.object().shape(keysValidation);

    return (
            <>
                <IncomeAlert incomeAlertOpen={incomeAlertOpen}/>

                <Formik
                        enableReinitialize={true}
                        initialValues={initialValues}
                        validationSchema={personalDetailSchema}
                        validateOnChange={true}
                        onSubmit={async (values: any, { setSubmitting, setValues }) => {
                            // if ((values["employedTime"] == 1 || values["employedTime"] == 2) && (carrierId == allianzId)) {
                            //      setOpenAlert(true);
                            //      return false;
                            // }
                            if (isFromClientDetail && (values["age"] < minAge || values["age"] > maxAge) && values["birthDay"] && values["birthMonth"] && values["birthYear"]) {
                                let { birthDay, birthMonth } = values;
                                delete values.age;
                                delete values.birthDay;
                                delete values.birthMonth;
                                delete values.birthYear;
                                setValues({
                                    ...values,
                                    age: initialValues.age,
                                    birthDay: birthDay,
                                    birthYear: initialValues.birthYear,
                                    birthMonth: birthMonth,
                                });
                                setInitialValues({
                                    ...values,
                                    age: initialValues.age,
                                    birthDay: birthDay,
                                    birthYear: initialValues.birthYear,
                                    birthMonth: birthMonth,
                                });
                            } else {
                                setInitialValues(values);
                            }

                            if (role === 5 || role === 6) {
                                delete values["contributionAmount"];
                                delete values["healthType"];
                            } else {
                                values["contributionAmount"] = values["contributionAmount"] ? values["contributionAmount"].split(",").join("") : 0;
                            }
                            if (!isFromClientDetail && values["age"] === 0) {
                                return false;
                            }
                            values["noOfPolicies"] = values["noOfPolicies"] ? values["noOfPolicies"] : 0;
                            //values["annualIncome1"] = values["annualIncome1"] ? values["annualIncome1"] : null;
                            //values["annualIncome2"] = values["annualIncome2"] ? values["annualIncome2"] : null;
                            values["employedTime"] = values["employedTime"] ? values["employedTime"] : 0;
                            values["employer"] = values["employer"] ? values["employer"] : "";
                            values["annualIncome"] = values["annualIncome"] && Number(values["annualIncome"]) !== 0 ? values["annualIncome"].split(",").join("") : null;
                            values["annualIncome1"] = values["annualIncome1"] && Number(values["annualIncome1"]) !== 0 ? values["annualIncome1"].split(",").join("") : null;
                            values["annualIncome2"] = values["annualIncome2"] && Number(values["annualIncome2"]) !== 0 ? values["annualIncome2"].split(",").join("") : null;
                            values["householdAnnualIncome"] = values["householdAnnualIncome"] ? values["householdAnnualIncome"].split(",").join("") : null;
                            values["householdNetWorth"] = values["householdNetWorth"] ? values["householdNetWorth"].split(",").join("") : null;
                            values["state"] = typeof values["state"] === 'object' ? values["state"].key : values["state"];
                            try {
                                await accountActions.updateUserBasicDetails(values, (clientPolicy && clientPolicy.id) || 0);
                                setTimeout(() => {
                                    if (!isFromClientDetail) {
                                        setNextStep();
                                    } else{
                                        setActionItem(
                                                ( role == 1 || role == 2) && values.usCitizen ? true
                                                :
                                                (clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned && values.usCitizen ? true : false )
                                        );
                                    }
                                    setSubmitting(false);  
                                }, 400);
                            } catch (e) {
                                return false;
                            }
                        }}
                >
                    {({
                          values,
                          errors,
                          touched,
                          handleChange,
                          setFieldValue,
                          handleBlur,
                          handleSubmit,
                          isSubmitting,
                          dirty,
                      }) => {
                        if (typeof setIsPersonalFormDirty === "function") {
                            setIsPersonalFormDirty(dirty);
                        }
                        if (typeof setIsFormSubmitting === "function") {
                            setIsFormSubmitting(isSubmitting);
                        }
                        if (Object.keys(errors).length >= 1 && Object.keys(touched).length > 1) {
                            let errArr = Object.keys(errors);
                            let incomeArr = errArr.filter((item) => {
                                if (typeof setIsPersonalFormDirty === "function" && item.indexOf("annualIncome") > -1) {
                                    setIsPersonalFormDirty(false);
                                }
                                return item.indexOf("annualIncome") > -1;
                            });
                            let touchArr = Object.keys(touched);
                            let incomeTouchArr = touchArr.filter((item) => {
                                return item.indexOf("annualIncome") > -1;
                            });
                            if (incomeArr.length > 1 && incomeTouchArr.length > 1) {
                                setIncomeAlertOpen(true);
                            } else {
                                setIncomeAlertOpen(false);
                            }
                        }

                        if (typeof setIsPersonalFormDirty === "function") {
                            if(Object.keys(errors).length >= 1 && Object.keys(touched).length >= 1){
                                if (typeof setValidationError === "function") {
                                    setValidationError(true);
                                }
                            } else {
                                if (typeof setValidationError === "function") {
                                    setValidationError(false);
                                }
                            }
                        }
                        return (
                                <form className="mt20 floatLeft w100" onSubmit={handleSubmit} autoComplete="off">
                                    <FocusError offset={true}/>
                                    <Grid container spacing={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={6} xl={4}>
                                                <Typography variant="caption" className="floatLeft">
                                                    <Label label={"Are you a U.S. citizen?"}
                                                           required={conditionalRequired}/>
                                                </Typography>
                                                <ToggleButtonGroup
                                                        className="toggleButtonGroup"
                                                        size="large"
                                                        color={"primary"}
                                                        exclusive
                                                        id={"usCitizen"}
                                                        value={values["usCitizen"]}
                                                        onChange={(e: any, val: boolean) => {
                                                            setFieldValue("usCitizen", val);
                                                            setFieldValue("employeeSSN", "");
                                                        }}
                                                >
                                                    <ToggleButton value={true} color={"primary"}
                                                                  disabled={clientSigned ? true : false}
                                                                  className={values["usCitizen"] ? "active" : ""}>
                                                        Yes
                                                    </ToggleButton>
                                                    <ToggleButton value={false}
                                                                  disabled={clientSigned ? true : false}
                                                                  className={values["usCitizen"] ? "" : "active"}>
                                                        No
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            </Grid>
                                            <Grid item xs={12} md={6} xl={4}>
                                                <Typography variant="caption" className="floatLeft">
                                                    <Label label={"How would you like to verify your identity?"}
                                                           required={conditionalRequired}/>
                                                </Typography>
                                                <ToggleButtonGroup
                                                        color={"primary"}
                                                        className="toggleButtonGroup"
                                                        size="large"
                                                        exclusive
                                                        id={"identityType"}
                                                        value={values["identityType"]}
                                                        onChange={(e: any, val: string) => {
                                                            setFieldValue("identityType", val);
                                                            setFieldValue("identityId", "");
                                                            setFieldValue("proofExpiryYear", 0);
                                                            setFieldValue("proofExpiryMonth", 0);
                                                            setProofExpired(false);
                                                        }}
                                                >
                                                    <ToggleButton value={"drivingLicence"}
                                                                  disabled={clientSigned ? true : false}
                                                                  className={values["identityType"] === "drivingLicence" ? "active" : ""}>
                                                        US DRIVER'S LICENSE
                                                    </ToggleButton>
                                                    <ToggleButton value={"passport"}
                                                                  disabled={clientSigned ? true : false}
                                                                  className={values["identityType"] === "drivingLicence" ? "" : "active"}>
                                                        US PASSPORT
                                                    </ToggleButton>
                                                </ToggleButtonGroup>
                                            </Grid>

                                            {fieldObj.map((field, index) => {
                                                return (
                                                        <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                                            <>
                                                                {
                                                                    CommonField(
                                                                            field,
                                                                            {
                                                                                values,
                                                                                errors,
                                                                                touched,
                                                                                handleChange,
                                                                                handleBlur,
                                                                                setFieldValue,
                                                                            },
                                                                    )
                                                                }
                                                            </>
                                                        </Grid>
                                                );
                                            })
                                            }
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={12}>
                                                <Typography variant="caption" className="floatLeft w100 mt10 mb15">
                                                    Expiry Date (must
                                                    match {values["identityType"] === "drivingLicence" ? "drivers license" : "passport"})
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            {fieldObj7.map((field, index) => {
                                                return (
                                                        <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                                            <>
                                                                {
                                                                    CommonField(
                                                                            field,
                                                                            {
                                                                                values,
                                                                                errors,
                                                                                touched,
                                                                                handleChange,
                                                                                handleBlur,
                                                                                setFieldValue,
                                                                            },
                                                                    )
                                                                }
                                                            </>
                                                        </Grid>
                                                );
                                            })
                                            }
                                            <>{proofExpired ?
                                                    <span className="f12 colorRed floatLeft w100 ml15">
                                                        {values["identityType"] === "drivingLicence" ?
                                                                "Drivers license" : "Passport"} has been expired.</span> : ""}
                                            </>
                                        </Grid>
                                        {fieldObj1.map((field, index) => {
                                            if ((role === 1 || role === 2) && values["usCitizen"]) {
                                                if (field["name"] === "blotSSN" && !client.blotSSN) {
                                                    return (<></>);
                                                } else {
                                                    if (field["name"] === "employeeSSN" && !(client && client.employeeSSN) && (client && client.blotSSN)) {
                                                        return (<></>);
                                                    }
                                                }
                                            } else {
                                                if (!values["usCitizen"] && field["name"] === "blotSSN") {
                                                    return (<></>);
                                                }
                                                if (field["name"] === "blotSSN" && !clientSigned) {
                                                    return (<></>);
                                                }
                                                if (values["usCitizen"] && field["name"] === "employeeSSN" && clientSigned) {
                                                    return (<></>);
                                                }
                                            }

                                            return (
                                                    <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                                        <div className="mt20">
                                                            {
                                                                CommonField(
                                                                        field,
                                                                        {
                                                                            values,
                                                                            errors,
                                                                            touched,
                                                                            handleChange,
                                                                            handleBlur,
                                                                            setFieldValue,
                                                                        },
                                                                )
                                                            }
                                                        </div>
                                                    </Grid>
                                            );
                                        })
                                        }
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={12}>
                                            <Typography variant="caption" className="floatLeft w100 mt40 mb15">
                                                Birth Date (must
                                                match {values["identityType"] === "drivingLicence" ? "drivers license" : "passport"})
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        {fieldObj4.map((field, index) => {
                                            return (
                                                    <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                                        <>
                                                            {
                                                                CommonField(
                                                                        field,
                                                                        {
                                                                            values,
                                                                            errors,
                                                                            touched,
                                                                            handleChange,
                                                                            handleBlur,
                                                                            setFieldValue,
                                                                        },
                                                                )
                                                            }
                                                        </>
                                                    </Grid>
                                            );
                                        })
                                        }
                                        <>{(values["age"] || values["age"] === 0) && (values["age"] < minAge || values["age"] > maxAge) && values["birthDay"] && values["birthMonth"] && values["birthYear"] ?
                                                <span className="f12 colorRed floatLeft w100 ml15">Participants age must be between {minAge}-{maxAge} - Contact your agent</span> : ""}</>
                                        <input name="age" type="hidden"/>
                                    </Grid>
                                    <span className="hLine"/>
                                    <Typography variant="h6" className="fontBold w100">Home Address</Typography>
                                    <Grid container spacing={2}>
                                        {fieldObj2.map((field, index) => {
                                            return (
                                                    <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                                        <div className="mt20">
                                                            {
                                                                CommonField(
                                                                        field,
                                                                        {
                                                                            values,
                                                                            errors,
                                                                            touched,
                                                                            handleChange,
                                                                            handleBlur,
                                                                            setFieldValue,
                                                                        },
                                                                )
                                                            }
                                                        </div>
                                                    </Grid>
                                            );
                                        })
                                        }
                                        {values["identityType"] === "drivingLicence" &&
                                        <Grid item xs={12} md={12} xl={8} className="floatLeft w100">
                                            <Typography variant="caption" className="floatLeft mt20">
                                                <Label label={"Does your home address match your drivers license?"}
                                                       required={true}/>
                                            </Typography>
                                            <ToggleButtonGroup
                                                    className="toggleButtonGroup" size="large"
                                                    value={values["isDocumentAddress"]} exclusive
                                                    onChange={(e: any, val: any) => {
                                                        setFieldValue("isDocumentAddress", val);
                                                    }}
                                            >
                                                <ToggleButton value={true} disabled={clientSigned ? true : false}
                                                              className={values["isDocumentAddress"] ? "active" : ""}>
                                                    Yes
                                                </ToggleButton>
                                                <ToggleButton value={false} disabled={clientSigned ? true : false}
                                                              className={values["isDocumentAddress"] ? "" : "active"}>
                                                    No
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        </Grid>
                                        }
                                    </Grid>
                                    <span className="hLine"/>
                                    <Typography variant="h6" className="w100 mb20">Income Details</Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6} xl={4}>
                                            <Typography variant="caption" className="floatLeft"> <Label
                                                    label={"Are you self employed?"}
                                                    required={true}/> </Typography>
                                            <ToggleButtonGroup
                                                    className="toggleButtonGroup mb15" size="large" exclusive
                                                    value={values["selfEmployed"]}
                                                    onChange={(e: any, val: any) => {
                                                        setSelfEmployed(val);
                                                        setFieldValue("selfEmployed", val);
                                                        if (carrierId === allianzId) {
                                                            setFieldValue("annualIncome1", "");
                                                            setFieldValue("annualIncome2", "");
                                                        }
                                                    }}
                                            >
                                                <ToggleButton value={true} disabled={clientSigned ? true : false}
                                                              className={values["selfEmployed"] ? "active" : ""}>
                                                    Yes
                                                </ToggleButton>
                                                <ToggleButton value={false} disabled={clientSigned ? true : false}
                                                              className={values["selfEmployed"] ? "" : "active"}>
                                                    No
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        </Grid>
                                        {fieldObj3.map((field, index) => {
                                            if ((carrierId == allianzId) && !selfEmployed && (field["name"] === "annualIncome2" || field["name"] === "annualIncome1")) {
                                                return;
                                            } else {
                                                return (
                                                        <Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                                            <div className="mt35">
                                                                {
                                                                    CommonField(
                                                                            field,
                                                                            {
                                                                                values,
                                                                                errors,
                                                                                touched,
                                                                                handleChange,
                                                                                handleBlur,
                                                                                setFieldValue,
                                                                            },
                                                                    )
                                                                }
                                                            </div>
                                                        </Grid>

                                                );
                                            }
                                            ;
                                        })
                                        }
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={12} xl={8}>
                                            <Typography variant="caption" className="floatLeft"> <Label
                                                    label={"Any existing Kai-Zen Plan policies?"}
                                                    required={true}/> </Typography>
                                            <ToggleButtonGroup className="toggleButtonGroup mb30" size="large" exclusive
                                                               value={values["existPolicies"]}
                                                               onChange={() => {
                                                                   setFieldValue("existPolicies", !values["existPolicies"]);
                                                                   setFieldValue("noOfPolicies", !values["existPolicies"] ? values["noOfPolicies"] : "");
                                                                   setExistPolicies(!values["existPolicies"]);
                                                               }}>
                                                <ToggleButton value={true} disabled={clientSigned ? true : false}
                                                              className={values["existPolicies"] ? "active" : ""}>
                                                    Yes
                                                </ToggleButton>
                                                <ToggleButton value={false} disabled={clientSigned ? true : false}
                                                              className={values["existPolicies"] ? "" : "active"}>
                                                    No
                                                </ToggleButton>
                                            </ToggleButtonGroup>
                                        </Grid>
                                        <Grid item xs={12} md={6} xl={4}>
                                            {fieldObj5.map((field, index) => {
                                                return (
                                                        existPolicies ?
                                                                <div key={index + field["name"]}>
                                                                    <div className="mt20 customFields">
                                                                        {
                                                                            CommonField(
                                                                                    field,
                                                                                    {
                                                                                        values,
                                                                                        errors,
                                                                                        touched,
                                                                                        handleChange,
                                                                                        handleBlur,
                                                                                        setFieldValue,
                                                                                    },
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div> : <></>
                                                );
                                            })
                                            }
                                        </Grid>
                                    </Grid>

                                    {(role === 1 || role === 2 || role === 4) &&
                                    <>
                                        <span className="hLine"/>
                                        <Typography variant="h6" className="w100 mb20">Contribution Amount</Typography>
                                        <Grid container spacing={2}>
                                            {fieldObj6.map((field, index) => {
                                                return (<><Grid item xs={12} md={6} xl={4} key={index + field["name"]}>
                                                            <div className="mt20 customFields">
                                                                {
                                                                    CommonField(
                                                                            field,
                                                                            {
                                                                                values,
                                                                                errors,
                                                                                touched,
                                                                                handleChange,
                                                                                handleBlur,
                                                                                setFieldValue,
                                                                            },
                                                                    )
                                                                }
                                                            </div>
                                                            {field["name"] == "contributionAmount" &&
                                                            <span className="f12 textLight">
                                                                     <NumberFormat
                                                                             value={minVal}
                                                                             displayType={"text"}
                                                                             thousandSeparator={true} prefix={"$"}
                                                                             renderText={value =>
                                                                                     <Box component="span">{value} </Box>}
                                                                     />
                                                                      minimum contribution (includes trust fees)
                                                                      <Tooltip arrow
                                                                               title={
                                                                                   <React.Fragment>
                                                                                       <Typography
                                                                                               variant="caption"
                                                                                               className="mb0">Annual
                                                                                           contribution
                                                                                           includes a <span
                                                                                                   className="textHighLight">{trustFeeText(client)}</span> trust
                                                                                           fee
                                                                                           per year
                                                                                           for
                                                                                           5
                                                                                           years. Trust pays the life
                                                                                           insurance premiums.
                                                                                           Minimum
                                                                                           contribution
                                                                                           is &nbsp; <span
                                                                                                   className="textHighLight ml5">
                                                                                               <NumberFormat
                                                                                                       value={minVal}
                                                                                                       displayType={"text"}
                                                                                                       thousandSeparator={true}
                                                                                                       prefix={"$"}
                                                                                                       renderText={value =>
                                                                                                               <Box component="span">{value} </Box>}
                                                                                               /></span> with
                                                                                           trust
                                                                                           fees.</Typography>
                                                                                   </React.Fragment>
                                                                               }
                                                                      >
                                                                        <IconButton aria-label="Info" color="primary">
                                                                            <InfoIcon/>
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </span>
                                                            }
                                                        </Grid>
                                                        </>
                                                );
                                            })
                                            }
                                        </Grid>
                                    </>
                                    }
                                    <span className="hLine"/>
                                    {(role === 1 || role === 2 || role === 4) ?
                                            <div style={{
                                                display: "none",
                                            }}><Button type="submit" disabled={!dirty || isSubmitting}
                                                       ref={personalDetailSubmit}></Button></div> :
                                            <Button
                                                    variant="contained"
                                                    color="primary"
                                                    className="floatRight mb30"
                                                    disabled={isSubmitting || (clientSigned ? true : false)}
                                                    type={"submit"}
                                            >
                                                Continue
                                            </Button>
                                    }

                                </form>
                        );
                    }}
                </Formik>
                <AllianzAlert setOpenAlert={setOpenAlert} open={openAlert} carrierName={carrierName}/>
            </>);
};

export default PersonalDetailForm;